import { ReactNode } from "react";
import { cn } from "@/utils/classes";
import { cva } from "class-variance-authority";
import { Tooltip } from "@/components/ui/tooltip";

/* Variants */
const variants = cva("card-body", {
  variants: {
    size: {
      small: "gap-1 p-4",
      large: "gap-2 p-7",
    },
  },
  defaultVariants: {
    size: "large",
  },
});

/* Prop Types */
interface CardBodyProps extends React.HTMLAttributes<HTMLDivElement> {
  title?: string;
  children?: ReactNode;
  size?: "small" | "large";
}

/*
 * CardBody component
 */
export const CardBody = ({ title, children, className, size }: CardBodyProps) => {
  return (
    <div className={cn(variants({ size }), className)}>
      {title && (
        <Tooltip content={title} position="top-start">
          <h3 className="truncate">{title}</h3>
        </Tooltip>
      )}
      {children}
    </div>
  );
};
